import * as React from 'react';

import classnames from 'classnames';

import type {DisplayOptionEntity} from 'nutshell-core/utils';

import {Button} from '../../button/button';
import {EntitySelectRow} from '../../entity/entity-select-row';
import {Popover} from '../../popover/popover';

import styles from './potential-peeps-dropdown.module.css';

type Props = {
    potentialPeeps: DisplayOptionEntity[];
    onSelectPeep: (arg1: DisplayOptionEntity) => void;
    popoverRef: {
        current: HTMLElement | null | undefined;
    };
    isPopover?: boolean;
    isInModal?: boolean;
    createButtonProps?: {
        shouldShow: boolean;
        onCreate: () => void;
        entityName: string;
        entityType: 'company' | 'person';
    };
};

export function PotentialPeepsDropdown(props: Props) {
    const {potentialPeeps, onSelectPeep, popoverRef, createButtonProps} = props;

    const anchorWidth =
        popoverRef && popoverRef.current && popoverRef.current.offsetWidth
            ? popoverRef.current.offsetWidth
            : 400;

    const dropdown = (
        <>
            {createButtonProps && createButtonProps.shouldShow && (
                <div
                    className={
                        potentialPeeps.length > 0
                            ? classnames(
                                  styles['create-button'],
                                  styles['create-button-with-dropdown']
                              )
                            : styles['create-button']
                    }
                >
                    <Button
                        variant='text-primary'
                        preventUnderline={true}
                        onClick={createButtonProps.onCreate}
                        isFullWidth={true}
                    >
                        + Create new {createButtonProps.entityType} {createButtonProps.entityName}
                    </Button>
                </div>
            )}
            <PotentialPeepsDropdownContent
                potentialPeeps={potentialPeeps}
                onSelectPeep={onSelectPeep}
                isPopover={props.isPopover}
            />
        </>
    );

    return props.isPopover ? (
        <Popover
            anchor={popoverRef.current}
            location='bottom'
            hideNub={true}
            customStyles={{
                width: anchorWidth,
            }}
            offsetY={-10}
            disableFocusTrapZone={true}
            preventLocationValidation={true}
            zIndex={props.isInModal ? 100000 : 99}
        >
            {dropdown}
        </Popover>
    ) : (
        dropdown
    );
}

type DropdownProps = {
    potentialPeeps: DisplayOptionEntity[];
    onSelectPeep: (arg1: DisplayOptionEntity) => void;
    isPopover?: boolean;
};

function PotentialPeepsDropdownContent(props: DropdownProps) {
    const {potentialPeeps, onSelectPeep, isPopover} = props;

    return (
        <div
            className={
                isPopover
                    ? classnames(styles.container, styles['scrollable-container'])
                    : styles.container
            }
        >
            {potentialPeeps.map((peep) => (
                <div key={peep.id} className={peep.isDisabled ? '' : styles.result}>
                    <Button
                        variant='text-secondary'
                        onClick={() => onSelectPeep(peep)}
                        preventUnderline={true}
                        isFullWidth={true}
                        noPadding={true}
                        disabled={peep.isDisabled}
                    >
                        <EntitySelectRow entity={peep} />
                    </Button>
                </div>
            ))}
        </div>
    );
}
